// extracted by mini-css-extract-plugin
export var avatarContainer = "_4c-1";
export var largeAvatarContainer = "_4c-2";
export var smallAvatarContainer = "_4c-0";